export default __webpack_public_path__ + "static/media/logoAVStarDark.c6ef3dd4.png";